import { CommonModule, Location } from '@angular/common';
import {
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { HEADER_CONSTANT } from '@core/constants/header.constant';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { Subject, takeUntil } from 'rxjs';
import { navBarData } from '../nav-bar/model/nav-bar-data';
import { MainLayoutService } from '@core/services/main-layout/main-layout.service';

import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { AvatorPipe } from '../../../shared/pipes/avator.pipe';
import { HeaderService } from '@core/services/header/header.service';
import { ClientNameService } from '@sharedModule/services/clientName/client-name.service';
interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
 
    AvatorPipe,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnDestroy {
  @Input() board: string = 'Home';
  @Input() boardNum: string = 'Home';
  @Output() toggleSideNav: EventEmitter<SideNavToggle> = new EventEmitter();
  collapsed = false;
  screenWidth = 0;
  navData = navBarData;
  public headerConstant = HEADER_CONSTANT;

  showBackBtn = false;
  #destroy$ = new Subject<void>();

  allRoutes = [
    'home',
    'notifications',
    'support',
    'faq',
  ];


  constructor(
    public router: Router,
    public _location: Location,
    public activatedRoute: ActivatedRoute,
    public localStorageService: LocalStorageService,
    public mainLayouService: MainLayoutService,
    public authenticationService: AuthenticationService,
    public headerService: HeaderService,
    public clientNameService:ClientNameService
  ) {
    // this.loadUserDetails();
  }

  // loadUserDetails(): void {
  //   this.headerService
  //     .getUserDetails()
  //     .pipe(takeUntil(this.#destroy$))
  //     .subscribe({
  //       next: x => {
  //         if (x.success) {
  //           this.headerService.userName.set({
  //             email: x.data.email,
  //             role: x.data.role.type,
  //             roleName:x.data.role.name,
  //             userId: x.data.userId,
  //           });
  //           this.headerService.completeUserDetails.set(x.data);  
  //           this.clientNameService.clientName.set(x.data.clientId?.name)
  //           this.authenticationService.setUserPermission(x.data.permissions);
  //         }
  //       },
  //     });
  // }
  closeSidebar(event: Event): void {
    this.collapsed = false;
    event.stopPropagation();
  }

  openSidebar(event: Event): void {
    this.collapsed = true;
    event.stopPropagation();
    this.toggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  openModal(event: Event): void {
    event.preventDefault();
    const menu = document.getElementById('pop-menu');
    menu?.classList.remove('hidden');
  }

  closeModal(event: Event): void {
    event.preventDefault();
    const close = document.getElementById('pop-menu');
    close?.classList.add('hidden');
  }

  @HostListener('document:click', ['$event'])
  contentClick(event: Event): void {
    if (this.collapsed) {
      this.closeSidebar(event);
    }
  }

  logout(): void {
    this.authenticationService.initializeLogout();
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }
}
